/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import './Loading.css';

class Loading extends Component {

  render() {
    return (
      <div className={cx('Loading', this.props.size, { inline: this.props.inline } )}>
        <img alt="Loading" src="https://s3-us-west-2.amazonaws.com/misc-cdn/loading_222.svg"/>
      </div>
    );
  }
}

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/components/partials/Loading.js
 **/